import React, { useState } from 'react'
import dynamicfunction from '../../../utils/dynamicfunction';
import ViewReverse from '../../../components/ViewReverse';
import { cn, formatNumbers } from '../../../utils/utils';
import Text from '../../../components/Text';
import dayjs from 'dayjs';
import { COLORS, fontSizes } from '../../../constants/constants';
import ViewItems from '../../../components/ViewItems';
import SarSymbol from '../../../components/SarSymbol';
import { ReactSVG } from 'react-svg';
import icons from '../../../constants/icons';

const TransactionView = ({ item, getContent, onClick }) => {
  const { TextWeight, direction, isArabic } = dynamicfunction();

  const [isOpen, setIsOpen] = useState(false);

  const inkind_subscription = item?.actionTypeId?.toString() === '5'
  const is_subscription = item?.actionTypeId?.toString() === '3'
  const is_redemption = item?.actionTypeId?.toString() === '1'
  const is_transfer = item?.actionTypeId?.toString() === '4'
  const is_topup = item?.actionTypeId?.toString() === '2'

  return (
    <div className='w-full rounded-xl overflow-hidden border border-grey'>
      <ViewReverse

        className={cn('items-center px-5 py-3 border-b transition-all duration-500 cursor-pointer bg-primary/15', isOpen ? 'border-b-grey' : 'border-b-transparent')}
        onClick={() => !is_topup && setIsOpen(!isOpen)}
      >
        <div dir={direction} className='grid grid-cols-2 gap-y-3 w-full relative'>
          {item?.details?.status && (
            <ViewReverse className={cn('flex-col items-start absolute mt-1 xl:mt-0 -top-3 xl:top-0', isArabic ? '-left-2 xl:left-0' : '-right-2 xl:right-0')}>
              <Text text={item?.details?.status} size={fontSizes.h12} className={'flex-1'} color='text-primary' weight={TextWeight.medium} />
            </ViewReverse>
          )}
          <ViewReverse className={cn('flex-col items-start', item?.details?.status && 'mt-2 xl:mt-0')}>
            <Text text={item?.actionType} size={fontSizes.h14} className={'flex-1'} color='text-primary' weight={TextWeight.medium} />
            <Text text={getContent('type')} size={fontSizes.h12} className={'flex-1'} weight={TextWeight.regular} color={'text-silver'} />
          </ViewReverse>
          <ViewReverse className={cn('flex-col items-start', item?.details?.status && 'mt-2 xl:mt-0')}>
            <ViewReverse>
              <SarSymbol color={item?.amount >= 0 ? 'text-green-600' : 'text-red'} />
              <Text
                text={item?.amount >= 0 ? '+' : '-'}
                size={fontSizes.h14}
                color={item?.amount >= 0 ? 'text-green-600' : 'text-red'}
                weight={TextWeight.medium}
              />
              <Text
                text={formatNumbers(Math.abs(item?.amount))}
                size={fontSizes.h14}
                color={item?.amount >= 0 ? 'text-green-600' : 'text-red'}
                weight={TextWeight.medium}
              />
            </ViewReverse>
            <Text text={getContent('amount')} size={fontSizes.h12} className={'flex-1'} weight={TextWeight.regular} color={'text-silver'} />
          </ViewReverse>
          <ViewReverse className={'flex-col items-start'}>
            <Text text={dayjs(item?.entryDate ?? new Date()).format("DD-MM-YYYY")} size={fontSizes.h14} className={'flex-1'} color='text-primary' weight={TextWeight.medium} />
            <Text text={getContent('date')} size={fontSizes.h12} className={'flex-1'} weight={TextWeight.regular} color={'text-silver'} />
          </ViewReverse>
          <ViewReverse className={'flex-col items-start'}>
            <ViewReverse>
              <SarSymbol color={'text-primary'} />
              <Text text={formatNumbers(item?.cashBalance)} size={fontSizes.h14} color='text-primary' weight={TextWeight.medium} />
            </ViewReverse>
            <Text text={getContent('cash_account_balance')} size={fontSizes.h12} className={'flex-1'} weight={TextWeight.regular} color={'text-silver'} />
          </ViewReverse>
        </div>
      </ViewReverse>

      <div className={cn('transition-all duration-500 overflow-hidden', isOpen ? "max-h-[500px]" : "max-h-0")}>
        {
          (is_subscription || inkind_subscription) &&
          <>
            <ViewReverse className={'items-center px-5 py-3 border-b border-b-grey'} isReverse={false}>
              <Text text={getContent('order_number')} size={fontSizes.h14} className={'flex-1'} color='text-black' />
              <Text text={item?.details?.transactionNo} size={fontSizes.h14} className={'flex-1'} color='text-black' />
            </ViewReverse>
            <ViewReverse className={'items-center px-5 py-3 border-b border-b-grey'} isReverse={false}>
              <Text text={getContent('fund_name')} size={fontSizes.h14} className={'flex-1'} color='text-black' />
              <Text text={item?.details?.fundName} size={fontSizes.h14} className={'flex-1'} color='text-black' />
            </ViewReverse>
            <ViewReverse className={'items-center px-5 py-3 border-b border-b-grey'} isReverse={false}>
              <Text text={getContent('units')} size={fontSizes.h14} className={'flex-1'} color='text-black' />
              <Text text={formatNumbers(item?.details?.units, 0)} size={fontSizes.h14} className={'flex-1'} color='text-black' />
            </ViewReverse>
            <ViewReverse className={'items-center px-5 py-3 border-b border-b-grey'} isReverse={false}>
              <Text text={getContent('currency')} size={fontSizes.h14} className={'flex-1'} color='text-black' />
              <SarSymbol className={'flex-1 text-black'} />
            </ViewReverse>
            <ViewReverse className={'items-center px-5 py-3 border-b border-b-grey'} isReverse={false}>
              <Text text={getContent('status')} size={fontSizes.h14} className={'flex-1'} color='text-black' />
              <Text text={item?.details?.status} size={fontSizes.h14} className={'flex-1'} color='text-black' />
            </ViewReverse>
            <ViewReverse className={'items-center px-5 py-3'} isReverse={false}>
              <Text text={getContent('comments')} size={fontSizes.h14} className={'flex-1'} color='text-black' />
              <Text text={item?.remarks || '-'} size={fontSizes.h14} className={'flex-1'} color='text-black' />
            </ViewReverse>
            {(item?.details?.canDownloadInvoice || item?.canDownloadInvoice) && (
              <ViewReverse className={'items-center px-5 py-3 border-t border-b-grey'} isReverse={false}>
                <Text text={getContent('download_invoice')} size={fontSizes.h14} className={'flex-1'} color='text-black' />
                <ViewReverse className={'items-center gap-3 flex-1 cursor-pointer'} onClick={onClick} isReverse={false}>
                  <Text text={getContent('download')} size={fontSizes.h14} color='text-primary' />
                  <ReactSVG src={icons.viewActionbtn} />
                </ViewReverse>
              </ViewReverse>
            )}
          </>
        }
        {
          is_redemption &&
          <>
            <ViewReverse className={'items-center px-5 py-3 border-b border-b-grey'} isReverse={false}>
              <Text text={getContent('fund_name')} size={fontSizes.h14} className={'flex-1'} color='text-black' />
              <Text text={item?.details?.fundName} size={fontSizes.h14} className={'flex-1'} color='text-black' />
            </ViewReverse>
            <ViewReverse className={'items-center px-5 py-3 border-b border-b-grey'} isReverse={false}>
              <Text text={getContent('units')} size={fontSizes.h14} className={'flex-1'} color='text-black' />
              <Text text={formatNumbers(item?.details?.units, 0)} size={fontSizes.h14} className={'flex-1'} color='text-black' />
            </ViewReverse>
          </>
        }
        {
          is_transfer &&
          <>
            <ViewReverse className={'items-center px-5 py-3 border-b border-b-grey'} isReverse={false}>
              <Text text={getContent('transfer_fee')} size={fontSizes.h14} className={'flex-1'} color='text-black' />
              <Text text={item?.details?.withdrawalTransferFee ?? "-"} size={fontSizes.h14} className={'flex-1'} color='text-black' leftSymbol />
            </ViewReverse>
            <ViewReverse className={'items-center px-5 py-3 border-b border-b-grey'} isReverse={false}>
              <Text text={getContent('transaction_number')} size={fontSizes.h14} className={'flex-1'} color='text-black' />
              <Text text={item?.details?.transactionNo || "-"} size={fontSizes.h14} className={'flex-1'} color='text-black' />
            </ViewReverse>
            <ViewReverse className={'items-center px-5 py-3 border-b border-b-grey'} isReverse={false}>
              <Text text={getContent('to_account')} size={fontSizes.h14} className={'flex-1'} color='text-black' />
              <Text text={item?.details?.withdrawalToAccount ?? "-"} size={fontSizes.h14} className={'flex-1'} color='text-black' />
            </ViewReverse>
            <ViewReverse className={'items-center px-5 py-3 border-b border-b-grey'} isReverse={false}>
              <Text text={getContent('status')} size={fontSizes.h14} className={'flex-1'} color='text-black' />
              <Text text={item?.details?.status} size={fontSizes.h14} className={'flex-1'} color='text-black' />
            </ViewReverse>
          </>
        }

      </div>
    </div>
  )
}

export default TransactionView
